import type { ReactNode } from "react";
import { authJourneyStyles as styles } from "./auth-journey";

const WORD_PATTERN = /[\p{L}\p{N}]+/gu;

export function organizationInitials(name: string): string {
  const words = name.match(WORD_PATTERN) ?? [];
  if (words.length === 0) return "OR";
  const first = words[0] ?? "O";
  if (words.length === 1) return first.slice(0, 2).toUpperCase();
  const last = words.at(-1) ?? first;
  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
}

/**
 * A privacy-preserving organisation identity block. It intentionally accepts
 * only organisation-level facts and capability copy — never member counts,
 * administrator email addresses, or other personal data.
 */
export function OrgIdentityBlock({
  name,
  description,
  initials = organizationInitials(name),
}: {
  name: string;
  description: ReactNode;
  initials?: string;
}) {
  return (
    <div className={styles.orgBlock}>
      <span className={styles.orgAvatar} aria-hidden="true">
        {initials}
      </span>
      <div className={styles.orgText}>
        <div className={styles.orgName}>{name}</div>
        <div className={styles.orgDescription}>{description}</div>
      </div>
    </div>
  );
}
